import { jsx as a } from "react/jsx-runtime";
import { cn as o } from "../../lib/utils.js";
function n({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "label",
    {
      "data-slot": "label",
      className: o(
        "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        e
      ),
      ...t
    }
  );
}
export {
  n as Label
};
//# sourceMappingURL=label.js.map
